<script>
import { getBookDetail } from '../../api/portal'
import Page from '../../components/page.vue'
import Tabs from '../../components/tabs.vue'
import TabPane from '../../components/tab-pane.vue'
import { formatDate } from '../../util/time'
import { bookDefaultCover } from '../../config/values'
export default {
  components: {
    Page,
    Tabs,
    TabPane
  },
  data () {
    return {
      detail: {},
      authors: '',
      desc: '',
      chapters: [],
      activeName: 'chapters',
      defaultCover: bookDefaultCover,
      loaded: false
    }
  },
  methods: {
    async fetch () {
      this.loaded = false
      const { data } = await getBookDetail(this.$route.params.id)
      this.loaded = true
      this.detail = data.body.book
      this.authors = Array.isArray(data.body.authors) ? data.body.authors.map(it => it.userName).join('/') : '--'
      this.desc = data.body.description
      this.chapters = data.body.teachingoutline
    },
    publishDate (date) {
      return formatDate(date, 'yyyy-MM-dd')
    }
  },
  async mounted () {
    await this.fetch()
  }
}
</script>

<template>
  <Page title="图书详情">
    <div :class="$style.container" v-if="loaded">
      <div :class="$style.book">
        <img :src="detail.bookCover || defaultCover" :alt="detail.bookName" />
        <div :class="$style.desc">
          <div :class="$style.name">{{detail.bookName}}</div>
          <div :class="$style.author">{{authors}}</div>
          <div :class="$style.meta">页码：{{detail.pageNumber}}</div>
          <div :class="$style.meta">ISBN：{{detail.isbn}}</div>
          <div :class="$style.meta">出版时间：{{publishDate(detail.publishDate)}}</div>
          <!-- <div :class="[$style.meta, $style.price]">￥{{detail.bookPrice}}</div> -->
        </div>
      </div>
      <Tabs v-model="activeName" gutter="40px" :class="$style.tabs">
        <TabPane label="章节目录" name="chapters">
          <div :class="$style.content" v-html="chapters"></div>
        </TabPane>
        <TabPane label="图书介绍" name="desc">
          <p :class="$style.content" v-html="desc"></p>
        </TabPane>
      </Tabs>
    </div>
  </Page>
</template>

<style lang="stylus" module>
.container
  background-color #fff

.book
  display flex
  padding 16px 16px 18px
  line-bottom-1px()

  > img
    flex 0 0 auto
    display block
    width 64px
    max-height 90px
    object-fit cover
    margin-right 16px

.tabs
  padding 0 16px

.desc
  flex 1
  position relative

.name
  middle-font()
  ellipsis()
  margin-bottom 3px

.author
  small-font()

.meta
  font-size 12px
  line-height 16px
  color $gray-400

.price
  color $primary-color
  position absolute
  bottom 0
  right 0

.content
  font-size 14px
  line-height 22px
</style>
